module.exports = __webpack_public_path__ + "img/Belchen_2016_B_Asal-8554.f8f58b16.jpeg";